import * as React from 'react';

import { useAssetsData } from '@/zustand/useAssetsData';
import { Modal } from '@/components/Modal';

export const QuestionnaireIframe = ({
  customer,
  isModalType,
  show,
  closeHandler
}: any) => {
  const {
    behavior_list: { fit_preference_url }
  } = useAssetsData((store) => store.assetsData) || {};

  const srcUrl = `${fit_preference_url}&firstName=${customer.firstName}&lastName=${customer.lastName}&email=${customer.email}&user_id=${customer.id}`;

  const close = () => {
    const seenUsers = JSON.parse(localStorage.getItem('surveySeen') || '{}');
    seenUsers[customer.id] = true;
    localStorage.setItem('surveySeen', JSON.stringify(seenUsers));
    closeHandler();
  };

  return (
    <>
      {show && (
        <>
          {isModalType ? (
            <Modal closeHandler={close} show={show}>
              <div style={{ padding: '25px 0' }}>
                <iframe src={srcUrl} width="600" height="700"></iframe>
              </div>
            </Modal>
          ) : (
            <div style={{ padding: '25px 0' }}>
              <iframe src={srcUrl} width="600" height="700"></iframe>
            </div>
          )}
        </>
      )}
    </>
  );
};
